import { Component, OnInit, DoCheck } from '@angular/core';
import { LoginRenderingService } from '../../../services/login/login-rendering.service';
import { Router } from '@angular/router';
import { MainHeaderlabel_EN } from '../../../models/labels/mainHeaderLabel_EN';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { LogoutModalComponent } from '../../../logout/logout-modal/logout-modal.component';
import { HomeModalComponent } from '../../../home-modal/home-modal.component';
import { ApiService } from '../../../services/api/api.service';
import { Constants } from '../../../models/constants';
import { QuoteRenderingService } from '../../../services/search/quote-rendering.service';
import { BorrowerDTO } from '../../../models/borrower/borrower-dto';
import { IncomeDTO } from '../../../models/borrower/income-dto';
import { LoanStep1 } from '../../../models/borrower/loan-step1';
import { LoanStep2 } from '../../../models/borrower/loan-step2';
import { Parameter } from '../../../models/borrower/loanFormParameter';
import { NewQuote } from '../../../models/search/new-quote';
import { QuotationEntityIdDto } from '../../../models/search/quotation-entity-id-dto';
import { SearchQuote } from '../../../models/search/search-quote';
import { BorrowerRenderingService } from '../../../services/borrower/borrower-rendering.service';
import { homeLabel_EN } from '../../../models/labels/homeLabel_EN';
import { LoginDTO } from '../../../models/login/loginDetails';
import { MainHeaderlabel_HN } from 'src/app/models/labels/mainHeaderLabel_HN';
import { homeLabel_HN } from 'src/app/models/labels/homeLabel_HN';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})

export class MainHeaderComponent implements OnInit, DoCheck {

  constructor(private loginRenderingService: LoginRenderingService, private router: Router, private data: ApiService,
    public dialog: MatDialog, private quoteService: QuoteRenderingService, private borrowerService: BorrowerRenderingService
  ) {
  }

  currentUser: LoginDTO

  label: any;
  logoname: string;
  oldLogoname: String;
  userName: string;
  dealerName: string;
  homeLabel: any;

  ngOnInit() {
    // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUser= this.loginRenderingService.currentUser;

    if (this.currentUser) {
      this.userName = this.currentUser.userId;
      this.dealerName = this.currentUser.dealerName;
    }
    this.logoname = this.brandChange();

    if (this.borrowerService.language) {
      if (this.borrowerService.language == "ENGLISH") {
        this.label = new MainHeaderlabel_EN();
        this.homeLabel = new homeLabel_EN();
      } else if (this.borrowerService.language == "HINDI") {
        this.label = new MainHeaderlabel_HN();
        this.homeLabel = new homeLabel_HN();
      }
    } else {
      this.label = new MainHeaderlabel_EN();
      this.homeLabel = new homeLabel_EN();
    }
  }

  ngDoCheck() {
    if (window.localStorage.getItem('logoImage') !== this.oldLogoname) {
      this.brandChange();
    }
    if (this.borrowerService.language) {
      if (this.borrowerService.language == "ENGLISH") {
        this.label = new MainHeaderlabel_EN();
        this.homeLabel = new homeLabel_EN();
      } else if (this.borrowerService.language == "HINDI") {
        this.label = new MainHeaderlabel_HN();
        this.homeLabel = new homeLabel_HN();
      }
    } else {
      this.label = new MainHeaderlabel_EN();
      this.homeLabel = new homeLabel_EN();
    }
  }

  checkAdmin() {
    // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let currentUser= this.loginRenderingService.currentUser;

    if (currentUser && currentUser.token) {
      if (currentUser.userId == "nrfadmin") {
        return true;
      }
      else return false;
    }
  }

  brandChange() {
    if (window.localStorage.getItem('logoImage') !== null) {
      this.logoname = window.localStorage.getItem('logoImage');
    } else {
      this.logoname = this.data.setLogoName();
    }
    this.oldLogoname = this.logoname;
    return this.logoname;
  }

  openLogout() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'logout';
    dialogConfig.autoFocus = false;
    this.dialog.open(LogoutModalComponent, dialogConfig);
  }

  homePage() {

    if (this.loginRenderingService.login.checkHomePage) {
      this.quoteService.checkModifyButton = false;
      const brand = this.loginRenderingService.currentUser;

      // const brand = JSON.parse(localStorage.getItem('currentUser'));
      window.localStorage.setItem('theme-name', brand.brands);
      window.localStorage.setItem('logoImage', brand.brands);
      this.data.setLocalStorage(brand.brands);
      localStorage.removeItem('logoImage');
      this.router.navigate(['/home']);
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.panelClass = 'home-modal';
      dialogConfig.autoFocus = false;
      this.dialog.open(HomeModalComponent, dialogConfig);
    }
  }

  howItWorks() {
    this.router.navigate(['/howItWorks']);
  }

  faq() {
    this.router.navigate(['/faq']);
  }

  openNav() {
    document.getElementById("mySidebar").style.width = "250px";
    // document.getElementById("main").style.marginRight = "250px";
    document.getElementById("backdrop").classList.add("show");
  }

  closeNav() {
    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("main").style.marginRight = "0";
    document.getElementById("backdrop").classList.remove("show");
  }

  onClick(value) {

    this.borrowerService.primaryBorrower = new BorrowerDTO();
    this.borrowerService.incomeBorrower = new IncomeDTO();
    this.borrowerService.incomeCoBorrower = new IncomeDTO();
    this.borrowerService.loanStep1 = new LoanStep1();
    this.borrowerService.loanStep2 = new LoanStep2();
    this.borrowerService.parameter = new Parameter();
    this.borrowerService.coApplicantBorrower = new BorrowerDTO();

    this.quoteService.newQuote = new NewQuote();
    this.quoteService.quotation = new QuotationEntityIdDto();
    this.quoteService.searchQuote = new SearchQuote();
    this.quoteService.checkModifyButton = false;

    // console.log("", this.loginRenderingService.login.checkHomePage);
    // if (this.loginRenderingService.login.checkHomePage) {

    if (!this.checkAdmin()) {

      if (value.toUpperCase() == Constants.CONST_ID_NEWCARQUOTE || value.toUpperCase() == Constants.CONST_ID_USEDCARQUOTE) {

        if (value == Constants.CONST_ID_NEWCARQUOTE) {

          this.quoteService.newOrUsed.checkNewOrUsed = "N";
        }
        else {
          this.quoteService.newOrUsed.checkNewOrUsed = "U";
        }
        this.router.navigate(['/search/select', { id: 'new' }]);
      }

      else if (value.toUpperCase() == Constants.CONST_ID_SEARCHCARQUOTE)
        this.router.navigate(['/search/select', { id: 'search' }]);

      else if (value.toUpperCase() == Constants.CONST_ID_TRACKCARQUOTE)
        this.router.navigate(['/track/trackApplication']);

      else if (value.toUpperCase() == Constants.CONST_ID_RECENT)
        this.router.navigate(['/recentActivities']);

      else if (value.toUpperCase() == Constants.CONST_ID_NOTIFICATION)
        this.router.navigate(['/notifications']);

      else if (value.toUpperCase() == Constants.CONST_ID_STATUS)
        this.router.navigate(['/approvalStatus']);

      else if (value.toUpperCase() == Constants.CONST_ID_MASTER)
        this.router.navigate(['/admin']);

    }

    else {
      if (value.toUpperCase() == Constants.CONST_ID_DATA_SYNC)
        this.router.navigate(['/dataSync']);

      else if (value.toUpperCase() == Constants.CONST_ID_BROADCAST)
        this.router.navigate(['/broadcastAdmin']);

      else if (value.toUpperCase() == Constants.CONST_ID_USERADMIN)
        this.router.navigate(['/userAdmin']);

      else if (value.toUpperCase() == Constants.CONST_ID_DASHBOARDADMIN)
        this.router.navigate(['/dashboardAdmin']);

      else if (value.toUpperCase() == Constants.CONST_ID_CONFIGADMIN)
        this.router.navigate(['/configAdmin']);

      else if (value.toUpperCase() == Constants.CONST_ID_IMAGEUPLOAD)
        this.router.navigate(['/imageuploads']);

      else if (value.toUpperCase() == Constants.CONST_ID_TASKMANAGER)
        this.router.navigate(['/taskManager']);

      else if (value.toUpperCase() == Constants.CONST_ID_FAQ)
        this.router.navigate(['/faqConfig']);

      else if (value.toUpperCase() == Constants.CONST_ID_DEALERDATA)
        this.router.navigate(['/dealerData']);

    }
    // }
    // else {
    //   const dialogConfig = new MatDialogConfig();
    //   dialogConfig.panelClass = 'home-modal';
    //   dialogConfig.autoFocus = false;
    //   this.dialog.open(HomeModalComponent, dialogConfig);
    // }
  }

  langChange(event) {
    console.log("akshay");
    if (event.target.value === 'EN') {
      this.borrowerService.language = "ENGLISH";
    } else if (event.target.value === 'HN') {
      this.borrowerService.language = "HINDI";
    }
  }


}